/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class LocaleKeys {
    static ANTIBURN_OSD_MESSAGE = 'ANTIBURN_OSD_MESSAGE';

    static AUDIO_TRACK_OVERLAY_TITLE = 'AUDIO_TRACK_OVERLAY_TITLE';

    static FIRST_AIRED = 'FIRST_AIRED';

    static FIRST_AIRS = 'FIRST_AIRS';

    static GUIDE_CHANNEL_OPTIONS_OVERLAY_TITLE = 'GUIDE_CHANNEL_OPTIONS_OVERLAY_TITLE';

    static GUIDE_CHANNEL_TYPES_ALL_CHANNELS = 'GUIDE_CHANNEL_TYPES_ALL_CHANNELS';

    static GUIDE_CHANNEL_TYPES_MY_CHANNELS = 'GUIDE_CHANNEL_TYPES_MY_CHANNELS';

    static GUIDE_DESCRIPTION_HIDDEN = 'GUIDE_DESCRIPTION_HIDDEN';

    static GUIDE_EXIT_CONFIRMATION_OVERLAY_DESCRIPTION =
        'GUIDE_EXIT_CONFIRMATION_OVERLAY_DESCRIPTION';

    static GUIDE_EXIT_CONFIRMATION_OVERLAY_TITLE = 'GUIDE_EXIT_CONFIRMATION_OVERLAY_TITLE';

    static GUIDE_SELECT_OPTIONS_MESSAGE = 'GUIDE_SELECT_OPTIONS_MESSAGE';

    static GUIDE_SELECT_PRESS_AND_HOLD_MESSAGE = 'GUIDE_SELECT_PRESS_AND_HOLD_MESSAGE';

    static GUIDE_SELECT_TO_WATCH_TEXT = 'GUIDE_SELECT_TO_WATCH_TEXT';

    static GUIDE_SELECTED_CHANNEL_TYPE_ALL_CHANNELS = 'GUIDE_SELECTED_CHANNEL_TYPE_ALL_CHANNELS';

    static GUIDE_SELECTED_CHANNEL_TYPE_MY_CHANNELS = 'GUIDE_SELECTED_CHANNEL_TYPE_MY_CHANNELS';

    static GUIDE_SETTINGS_MESSAGE_FIRST_PART = 'GUIDE_SETTINGS_MESSAGE_FIRST_PART';

    static GUIDE_SETTINGS_MESSAGE_MIDDLE_PART = 'GUIDE_SETTINGS_MESSAGE_MIDDLE_PART';

    static GUIDE_SETTINGS_MESSAGE_LAST_PART = 'GUIDE_SETTINGS_MESSAGE_LAST_PART';

    static GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_DESCRIPTION =
        'GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_DESCRIPTION';

    static GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_TITLE = 'GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_TITLE';

    static GUIDE_TITLE_HIDDEN = 'GUIDE_TITLE_HIDDEN';

    static GUIDE_WHISPER_MESSAGE = 'GUIDE_WHISPER_MESSAGE';

    static LANGUAGE_NOT_SUPPORTED_OVERLAY_DESCRIPTION =
        'LANGUAGE_NOT_SUPPORTED_OVERLAY_DESCRIPTION';

    static LANGUAGE_NOT_SUPPORTED_OVERLAY_TITLE = 'LANGUAGE_NOT_SUPPORTED_OVERLAY_TITLE';

    static LIVE_TV_ACTION_STRIP_CHANGE_AUDIO_TRACK = 'LIVE_TV_ACTION_STRIP_CHANGE_AUDIO_TRACK';

    static LIVE_TV_ACTION_STRIP_CHANGE_SUBTITLES_CC_LANGUAGE =
        'LIVE_TV_ACTION_STRIP_CHANGE_SUBTITLES_CC_LANGUAGE';

    static LIVE_TV_ACTION_STRIP_RESUME = 'LIVE_TV_ACTION_STRIP_RESUME';

    static LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_OFF =
        'LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_OFF';

    static LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_ON = 'LIVE_TV_ACTION_STRIP_TURN_SUBTITLES_CC_ON';

    static LIVE_TV_ADULT_OSD_MESSAGE = 'LIVE_TV_ADULT_OSD_MESSAGE';

    static LIVE_TV_ADVANCE_NOT_ALLOWED = 'LIVE_TV_ADVANCE_NOT_ALLOWED';

    static LIVE_TV_APP_SESSION_EXPIRED_TITLE = 'LIVE_TV_APP_SESSION_EXPIRED_TITLE';

    static LIVE_TV_BANNER_TIP_PRESS_AND_HOLD_LIVE_TV_TEXT =
        'LIVE_TV_BANNER_TIP_PRESS_AND_HOLD_LIVE_TV_TEXT';

    static LIVE_TV_BANNER_TIP_PRESS_AND_HOLD_TO_TEXT = 'LIVE_TV_BANNER_TIP_PRESS_AND_HOLD_TO_TEXT';

    static LIVE_TV_CANNOT_PLAY_ON_THIS_DEVICE_OSD_MESSAGE =
        'LIVE_TV_CANNOT_PLAY_ON_THIS_DEVICE_OSD_MESSAGE';

    static LIVE_TV_CANT_PLAY_TITLE = 'LIVE_TV_CANT_PLAY_TITLE';

    static LIVE_TV_CANT_WATCH_SHOWS_TITLE = 'LIVE_TV_CANT_WATCH_SHOWS_TITLE';

    static LIVE_TV_CANT_WATCH_NOW_TITLE = 'LIVE_TV_CANT_WATCH_NOW_TITLE';

    static LIVE_TV_CANT_PLAY_MESSAGE = 'LIVE_TV_CANT_PLAY_MESSAGE';

    static LIVE_TV_CANT_WATCH_SHOWS_MESSAGE = 'LIVE_TV_CANT_WATCH_SHOWS_MESSAGE';

    static LIVE_TV_CANT_WATCH_NOW_MESSAGE = 'LIVE_TV_CANT_WATCH_NOW_MESSAGE';

    static LIVE_TV_CHANGE_AUDIO_TRACK_MESSAGE = 'LIVE_TV_CHANGE_AUDIO_TRACK_MESSAGE';

    static LIVE_TV_CHANGE_SUBTITLES_CC_LANGUAGE_MESSAGE =
        'LIVE_TV_CHANGE_SUBTITLES_CC_LANGUAGE_MESSAGE';

    static LIVE_TV_CHANNEL_NOT_SUBSCRIBED_FIRST_HALF = 'LIVE_TV_CHANNEL_NOT_SUBSCRIBED_FIRST_HALF';

    static LIVE_TV_CHANNEL_NOT_SUBSCRIBED_SECOND_HALF =
        'LIVE_TV_CHANNEL_NOT_SUBSCRIBED_SECOND_HALF';

    static LIVE_TV_CHANNEL_NOT_SUBSCRIBED_ERROR_CODE = 'LIVE_TV_CHANNEL_NOT_SUBSCRIBED_ERROR_CODE';

    static LIVE_TV_DEVICE_CONFIG_ERROR_MESSAGE = 'LIVE_TV_DEVICE_CONFIG_ERROR_MESSAGE';

    static LIVE_TV_DEVICE_CONFIG_ERROR_TITLE = 'LIVE_TV_DEVICE_CONFIG_ERROR_TITLE';

    static LIVE_TV_FULL_INFO_BANNER_DESCRIPTION_NOT_AVAILABLE =
        'LIVE_TV_FULL_INFO_BANNER_DESCRIPTION_NOT_AVAILABLE';

    static LIVE_TV_FULL_INFO_BANNER_TITLE_NOT_AVAILABLE =
        'LIVE_TV_FULL_INFO_BANNER_TITLE_NOT_AVAILABLE';

    static LIVE_TV_FAST_FORWARD_NOT_ALLOWED = 'LIVE_TV_FAST_FORWARD_NOT_ALLOWED';

    static LIVE_TV_INACTIVITY_OSD_MESSAGE = 'LIVE_TV_INACTIVITY_OSD_MESSAGE';

    static LIVE_TV_IN_BLACKLIST_OSD_MESSAGE = 'LIVE_TV_IN_BLACKLIST_OSD_MESSAGE';

    static LIVE_TV_MEDIA_BUTTON_ADVANCE = 'LIVE_TV_MEDIA_BUTTON_ADVANCE';

    static LIVE_TV_MEDIA_BUTTON_FORWARD = 'LIVE_TV_MEDIA_BUTTON_FORWARD';

    static LIVE_TV_MEDIA_BUTTON_GO_TO_END = 'LIVE_TV_MEDIA_BUTTON_GO_TO_END';

    static LIVE_TV_MEDIA_BUTTON_GO_TO_LIVE = 'LIVE_TV_MEDIA_BUTTON_GO_TO_LIVE';

    static LIVE_TV_MEDIA_BUTTON_LIVE = 'LIVE_TV_MEDIA_BUTTON_LIVE';

    static LIVE_TV_MEDIA_BUTTON_PAUSE = 'LIVE_TV_MEDIA_BUTTON_PAUSE';

    static LIVE_TV_MEDIA_BUTTON_PLAY = 'LIVE_TV_MEDIA_BUTTON_PLAY';

    static LIVE_TV_MEDIA_BUTTON_REPLAY = 'LIVE_TV_MEDIA_BUTTON_REPLAY';

    static LIVE_TV_MEDIA_BUTTON_REWIND = 'LIVE_TV_MEDIA_BUTTON_REWIND';

    static LIVE_TV_MEDIA_BUTTON_START_FROM_BUFFER = 'LIVE_TV_MEDIA_BUTTON_START_FROM_BUFFER';

    static LIVE_TV_MEDIA_BUTTON_START_OVER = 'LIVE_TV_MEDIA_BUTTON_START_OVER';

    static LIVE_TV_OFF = 'LIVE_TV_OFF';

    static LIVE_TV_ON = 'LIVE_TV_ON';

    static LIVE_TV_OOH_OSD_MESSAGE = 'LIVE_TV_OOH_OSD_MESSAGE';

    static LIVE_TV_OUT_OF_REGION_OSD_MESSAGE = 'LIVE_TV_OUT_OF_REGION_OSD_MESSAGE';

    static LIVE_TV_LOCATION_RESTRICTION_OSD_MESSAGE = 'LIVE_TV_LOCATION_RESTRICTION_OSD_MESSAGE';

    static LIVE_TV_PAUSE_NOT_SUPPORTED_MESSAGE = 'LIVE_TV_PAUSE_NOT_SUPPORTED_MESSAGE';

    static LIVE_TV_PLAYER_ENFORCEMENT_ERROR_MESSAGE = 'LIVE_TV_PLAYER_ENFORCEMENT_ERROR_MESSAGE';

    static LIVE_TV_PLAYER_ENFORCEMENT_ERROR_TITLE = 'LIVE_TV_PLAYER_ENFORCEMENT_ERROR_TITLE';

    static LIVE_TV_PLAYER_ERROR_TITLE = 'LIVE_TV_PLAYER_ERROR_TITLE';

    static LIVE_TV_REWIND_NOT_ALLOWED = 'LIVE_TV_REWIND_NOT_ALLOWED';

    static LIVE_TV_REPLAY_NOT_ALLOWED = 'LIVE_TV_REPLAY_NOT_ALLOWED';

    static LIVE_TV_SPINNER_GETTING_YOUR_SHOW = 'LIVE_TV_SPINNER_GETTING_YOUR_SHOW';

    static LIVE_TV_SPINNER_GOING_TO_LIVE_TV = 'LIVE_TV_SPINNER_GOING_TO_LIVE_TV';

    static LIVE_TV_SPINNER_LOADING_VIDEO = 'LIVE_TV_SPINNER_LOADING_VIDEO';

    static LIVE_TV_STANDARD_INFO_BANNER_UP_NEXT = 'LIVE_TV_STANDARD_INFO_BANNER_UP_NEXT';

    static LIVE_TV_STANDARD_INFO_BANNER_LIVE_TV_STRING =
        'LIVE_TV_STANDARD_INFO_BANNER_LIVE_TV_STRING';

    static LIVE_TV_TURN_SUBTITLES_CC_ON_MESSAGE = 'LIVE_TV_TURN_SUBTITLES_CC_ON_MESSAGE';

    static LIVE_TV_SUBSCRIPTION_REQUIRED_TITLE = 'LIVE_TV_SUBSCRIPTION_REQUIRED_TITLE';

    static LIVE_TV_APP_SESSION_EXPIRED_MESSAGE = 'LIVE_TV_APP_SESSION_EXPIRED_MESSAGE';

    static LIVE_TV_SUBSCRIPTION_REQUIRED_MESSAGE = 'LIVE_TV_SUBSCRIPTION_REQUIRED_MESSAGE';

    static LIVE_TV_SOMETHING_WENT_WRONG_MESSAGE = 'LIVE_TV_SOMETHING_WENT_WRONG_MESSAGE';

    static LIVE_TV_SOMETHING_WENT_WRONG_TITLE = 'LIVE_TV_SOMETHING_WENT_WRONG_TITLE';

    static LIVE_TV_GRACE_PERIOD_ENDED_ERROR_TITLE = 'LIVE_TV_GRACE_PERIOD_ENDED_ERROR_TITLE';

    static LIVE_TV_GRACE_PERIOD_ENDED_ERROR_MESSAGE = 'LIVE_TV_GRACE_PERIOD_ENDED_ERROR_MESSAGE';

    static LIVE_TV_TOO_MANY_STREAMS_FOR_RESOURCE_MESSAGE =
        'LIVE_TV_TOO_MANY_STREAMS_FOR_RESOURCE_MESSAGE';

    static LIVE_TV_NO_SESSION_MESSAGE = 'LIVE_TV_NO_SESSION_MESSAGE';

    static LIVE_TV_UNABLE_TO_PLAY_MESSAGE = 'LIVE_TV_UNABLE_TO_PLAY_MESSAGE';

    static NO_NETWORK_OVERLAY_DESCRIPTION = 'NO_NETWORK_OVERLAY_DESCRIPTION';

    static NO_NETWORK_OVERLAY_TITLE = 'NO_NETWORK_OVERLAY_TITLE';

    static NOT_AVAILABLE = 'NOT_AVAILABLE';

    static OVERLAY_DESCRIPTION_NOT_AVAILABLE = 'OVERLAY_DESCRIPTION_NOT_AVAILABLE';

    static OVERLAY_OPTION_CANCEL_TEXT = 'OVERLAY_OPTION_CANCEL_TEXT';

    static OVERLAY_OPTION_EXIT_TEXT = 'OVERLAY_OPTION_EXIT_TEXT';

    static OVERLAY_OPTION_GO_TO_SETTINGS = 'OVERLAY_OPTION_GO_TO_SETTINGS';

    static OVERLAY_OPTION_OK_TEXT = 'OVERLAY_OPTION_OK_TEXT';

    static OVERLAY_OPTION_RESUME_PLAYING_TEXT = 'OVERLAY_OPTION_RESUME_PLAYING_TEXT';

    static OVERLAY_OPTION_START_OVER_FROM_BEGINNING_TEXT =
        'OVERLAY_OPTION_START_OVER_FROM_BEGINNING_TEXT';

    static OVERLAY_OPTIONS_CHANNELS_TEXT = 'OVERLAY_OPTIONS_CHANNELS_TEXT';

    static OVERLAY_OPTIONS_SEE_CHANNEL_OPTIONS_TEXT = 'OVERLAY_OPTIONS_SEE_CHANNEL_OPTIONS_TEXT';

    static OVERLAY_OPTIONS_WATCH_LIVE_TEXT = 'OVERLAY_OPTIONS_WATCH_LIVE_TEXT';

    static OVERLAY_OPTIONS_WATCH_NOW_FROM_TEXT = 'OVERLAY_OPTIONS_WATCH_NOW_FROM_TEXT';

    static OVERLAY_OPTIONS_WATCH_NOW_TEXT = 'OVERLAY_OPTIONS_WATCH_NOW_TEXT';

    static OVERLAY_SHOW_NOT_AVAILABLE_TO_WATCH_TEXT = 'OVERLAY_SHOW_NOT_AVAILABLE_TO_WATCH_TEXT';

    static OVERLAY_TITLE_NOT_AVAILABLE_TEXT = 'OVERLAY_TITLE_NOT_AVAILABLE_TEXT';

    static SETTINGS_ACCOUNT = 'SETTINGS_ACCOUNT';

    static SETTINGS_APP_VERSION = 'SETTINGS_APP_VERSION';

    static SETTINGS_CLEAR_TEXT = 'SETTINGS_CLEAR_TEXT';

    static SETTINGS_CONFIRM_APP_RESET = 'SETTINGS_CONFIRM_APP_RESET';

    static SETTINGS_CONFIRM_APP_SIGN_OUT = 'SETTINGS_CONFIRM_APP_SIGN_OUT';

    static SETTINGS_ENGLISH = 'SETTINGS_ENGLISH';

    static SETTINGS_HEADER_TITLE_DEFAULT = 'SETTINGS_HEADER_TITLE_DEFAULT';

    static SETTINGS_HEADER_TITLE_MENU_LANGUAGE = 'SETTINGS_HEADER_TITLE_MENU_LANGUAGE';

    static SETTINGS_HEADER_TITLE_VIDEO_WINDOW = 'SETTINGS_HEADER_TITLE_VIDEO_WINDOW';

    static SETTINGS_HELP = 'SETTINGS_HELP';

    static SETTINGS_MENU_LANGUAGE = 'SETTINGS_MENU_LANGUAGE';

    static SETTINGS_MENU_LANGUAGE_PAGE_DESCRIPTION = 'SETTINGS_MENU_LANGUAGE_PAGE_DESCRIPTION';

    static SETTINGS_PRIVACY_POLICY = 'SETTINGS_PRIVACY_POLICY';

    static SETTINGS_RESET_APP = 'SETTINGS_RESET_APP';

    static SETTINGS_RESET_TEXT = 'SETTINGS_RESET_TEXT';

    static SETTINGS_RESET_TO_DEFAULT_TEXT = 'SETTINGS_RESET_TO_DEFAULT_TEXT';

    static SETTINGS_SHELL_APP_VERSION = 'SETTINGS_SHELL_APP_VERSION';

    static SETTINGS_SIGN_OUT = 'SETTINGS_SIGN_OUT';

    static SETTINGS_SIGN_OUT_APP_EXIT_TEXT = 'SETTINGS_SIGN_OUT_APP_EXIT_TEXT';

    static SETTINGS_SIGN_OUT_ERROR = 'SETTINGS_SIGN_OUT_ERROR';

    static SETTINGS_SIGN_OUT_ERROR_TEXT = 'SETTINGS_SIGN_OUT_ERROR_TEXT';

    static SETTINGS_SIGN_OUT_NETWORK_ERROR_TEXT = 'SETTINGS_SIGN_OUT_NETWORK_ERROR_TEXT';

    static SETTINGS_SIGN_OUT_OF = 'SETTINGS_SIGN_OUT_OF';

    static SETTINGS_SIGN_OUT_SERVICE_ERROR_TEXT = 'SETTINGS_SIGN_OUT_SERVICE_ERROR_TEXT';

    static SETTINGS_SIGN_OUT_SPINNER_MESSAGE = 'SETTINGS_SIGN_OUT_SPINNER_MESSAGE';

    static SETTINGS_SPANISH = 'SETTINGS_SPANISH';

    static SETTINGS_SUPPORT = 'SETTINGS_SUPPORT';

    static SETTINGS_USER_PREFERENCES = 'SETTINGS_USER_PREFERENCES';

    static SETTINGS_VIDEO_WINDOW = 'SETTINGS_VIDEO_WINDOW';

    static SETTINGS_VIDEO_WINDOW_OPTION_NO = 'SETTINGS_VIDEO_WINDOW_OPTION_NO';

    static SETTINGS_VIDEO_WINDOW_OPTION_YES = 'SETTINGS_VIDEO_WINDOW_OPTION_YES';

    static SETTINGS_VIDEO_WINDOW_PAGE_DESCRIPTION = 'SETTINGS_VIDEO_WINDOW_PAGE_DESCRIPTION';

    static SIGN_IN_ACCOUNT_LOCKED_DESCRIPTION = 'SIGN_IN_ACCOUNT_LOCKED_DESCRIPTION';

    static SIGN_IN_AND_ENTER = 'SIGN_IN_AND_ENTER';

    static SIGN_IN_CODE_EXPIRED_MESSAGE = 'SIGN_IN_CODE_EXPIRED_MESSAGE';

    static SIGN_IN_ERROR_ACCOUNT_LOCKED_TITLE = 'SIGN_IN_ERROR_ACCOUNT_LOCKED_TITLE';

    static SIGN_IN_ERROR_OVERLAY_DESCRIPTION = 'SIGN_IN_ERROR_OVERLAY_DESCRIPTION';

    static SIGN_IN_ERROR_OVERLAY_TITLE = 'SIGN_IN_ERROR_OVERLAY_TITLE';

    static SIGN_IN_ERROR_TOO_MANY_DEVICES_TITLE = 'SIGN_IN_ERROR_TOO_MANY_DEVICES_TITLE';

    static SIGN_IN_GO_TO = 'SIGN_IN_GO_TO';

    static SIGN_IN_NEW_ACTIVATION_BUTTON_LABEL = 'SIGN_IN_NEW_ACTIVATION_BUTTON_LABEL';

    static SIGN_IN_REFRESH_MESSAGE = 'SIGN_IN_REFRESH_MESSAGE';

    static SIGN_IN_SPINNER_MESSAGE = 'SIGN_IN_SPINNER_MESSAGE';

    static SIGN_IN_TO = 'SIGN_IN_TO';

    static SIGN_IN_TOO_MANY_DEVICES_DESCRIPTION = 'SIGN_IN_TOO_MANY_DEVICES_DESCRIPTION';

    static SOCU_ERROR_OVERLAY_DESCRIPTION = 'SOCU_ERROR_OVERLAY_DESCRIPTION';

    static SOCU_ERROR_OVERLAY_TITLE = 'SOCU_ERROR_OVERLAY_TITLE';

    static SOS_OVERLAY_DESCRIPTION = 'SOS_OVERLAY_DESCRIPTION';

    static SOS_OVERLAY_OPTION_EXIT = 'SOS_OVERLAY_OPTION_EXIT';

    static SOS_OVERLAY_TITLE = 'SOS_OVERLAY_TITLE';

    static SUBTITLE_OVERLAY_TITLE = 'SUBTITLE_OVERLAY_TITLE';

    static LIVE_TV_STREAM_STATS = 'LIVE_TV_STREAM_STATS';

    static TEMPORARY_SERVICE_CONNECTION_ISSUE_DESCRIPTION =
        'TEMPORARY_SERVICE_CONNECTION_ISSUE_DESCRIPTION';

    static TEMPORARY_SERVICE_CONNECTION_ISSUE_TITLE = 'TEMPORARY_SERVICE_CONNECTION_ISSUE_TITLE';
}
